/**
 * Maintain a cache of the POIs already fetched
 * @example
 *
 * cache.set("id", {});
 */
export default new Map();


// WEBPACK FOOTER //
// ./assets/shared/cache.js